import styled from 'styled-components';

const ResultActionModalWrapper = styled.div<any>`
  ${( { styles } ) => styles && styles}
`;

const Content = styled.div<any>`
  padding: 10px 34px 50px 34px;
  text-align: center;
  ${( { styles } ) => styles && styles}
`;

const Title = styled.h2<any>`
  margin: 0 auto;
  display: block;
  font-size: 21px;
  ${( { styles } ) => styles && styles}
`;

const Text = styled.p<any>`
  margin: 0 auto;
  display: block;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.shadeDark};

  ${( { styles } ) => styles && styles}
`;

const Image = styled.img.attrs(({ src }) => ({ src }))<any>`
  margin: 0 auto;
  display: block;

  ${( { styles } ) => styles && styles}
`;

export default ResultActionModalWrapper;
export {
  Content,
  Title,
  Text,
  Image
}
